import {
  CURRENT_MAC_RELEASE,
  type MacReleaseManifest,
} from "../releases/macReleaseManifest";

/**
 * The public artifact URL and digest come from the same manifest served to the
 * menu bar app. Update CURRENT_MAC_RELEASE only after release verification.
 */
export type MacRelease = MacReleaseManifest;
export const MAC_RELEASE: MacRelease = CURRENT_MAC_RELEASE;
